export const clients = [
    { src: "./logoipsum-288.svg", name: "Logo" },
    { src: "./logoipsum-317.svg", name: "Logo" },
    { src: "./logoipsum-321.svg", name: "Logo" },
    { src: "./logoipsum-323.svg", name: "Logo" },
    { src: "./logoipsum-330.svg", name: "Logo" },
    { src: "./logoipsum-331.svg", name: "Logo" },
];
